import * as React from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Button from '@mui/material/Button';
import ImportIcon from '@mui/icons-material/SystemUpdateAlt';
import Link from '@mui/material/Link';

export default function BasicMenu() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <Button
        id="basic-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        className="tw-mt-2"
        size="small"
      >
        <ImportIcon />
        <span className="pl-1 sm:tw-block tw-hidden">Import</span>
      </Button>

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <Link href="/dashboard/drafts/import/hive">
          <MenuItem onClick={handleClose}>Hive</MenuItem>
        </Link>
        <Link href="/dashboard/drafts/import/wordpress">
          <MenuItem onClick={handleClose}>WordPress</MenuItem>
        </Link>
        <Link href="/dashboard/drafts/import/blogger">
          <MenuItem onClick={handleClose}>Blogger.com</MenuItem>
        </Link>
      </Menu>
    </div>
  );
}
